<template>
    <span></span>
</template>

<script>

export default {
    name: "CountdownStartClass",
    props: [
        'tutoring',
        'test'
    ],
    data() {
        const time_current = Math.floor(Date.now() / 1000);

        const time_countdown_1 = this.tutoring.time_start - time_current;

        return {
            time_countdown_1: time_countdown_1,
        };
    },

    watch: {
        time_countdown_1: {
            handler(value) {
                if ( value > 0 && value < 60*5) {
                    setTimeout(() => {
                        this.time_countdown_1--;
                    }, 1000);
                }else{
                    // this.tutoring.status = 4;
                }
            },
            immediate: true
        },
    },

    created() {},

    methods: {

    }
}
</script>

<style scoped>

</style>
